import { cloneDeep, times } from 'lodash';
import createTaskType from '../../createTaskType';
import Editor from './Editor';

export default createTaskType({
    id: 'comic_story',
	label: 'Comic Story',
    skill: 'reading_writing',
    v2: true,
    hasRubric: true,

    backgroundImages: { count: 1 },

    editor: Editor,
    createItemsTemplate: () => times(6, index => ({
        is_example: index === 0,
        ...(index === 0 && { rubric_id: '' }),

        stimulus_text: '',
        question_1: '',
        question_2: '',
        is_capital: false,

        answers: [{
            is_correct_answer: true,
            key: [],
        }],
    })),


    convertToUploadFormat(task, { isNew }) {
        task = cloneDeep(task);


        // NB: Backend incorrectly has a second bg image field, but allows null.
        if (isNew) {
            task.background_image_2 = null;
        } else {
            delete task.background_image_2;
        }

        task.items = task.items.map(item => ({
            ...item,
            // These must be null rather than empty
            stimulus_text: item.stimulus_text?.length >= 1 ? item.stimulus_text : null,
            question_1: item.question_1 || null,
            question_2: item.question_2 || null,

            answers: item.answers.map(answer => {
                if (typeof answer.key === 'string') {
                    answer.key = answer.key.split(',').map(x => x.trim()).filter(x => !!x)
                }
                return answer;
            })
        }));
        return task;
    },

    getKeys: (item) => {
        return item.answers.filter(x => x.is_correct_answer).map(x => x?.key?.join(', ') ?? 'N/A');
    }
});